var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    viewBox: "0 0 10 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 63"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.10847 0C2.87544 0 2.68652 0.188916 2.68652 0.421949C2.68652 0.654982 2.87544 0.843898 3.10847 0.843898H8.31251C8.77859 0.843898 9.15641 1.22173 9.15641 1.6878V10.277C9.15641 10.51 9.34532 10.6989 9.57836 10.6989C9.81138 10.6989 10.0003 10.51 10.0003 10.277V1.6878C10.0003 0.755649 9.24466 0 8.31251 0H3.10847Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.21533 1.50879H0V11.3924C0 12.0915 0.566739 12.6583 1.26585 12.6583H7.21533C7.91443 12.6583 8.48117 12.0915 8.48117 11.3924V2.77464C8.48117 2.07553 7.91443 1.50879 7.21533 1.50879ZM0.843898 11.3924V2.35269H7.21533C7.44835 2.35269 7.63727 2.54161 7.63727 2.77464V11.3924C7.63727 11.6254 7.44835 11.8144 7.21533 11.8144H1.26585C1.03281 11.8144 0.843898 11.6254 0.843898 11.3924Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyLinkIcon);
export default __webpack_public_path__ + "static/media/copyLinkIcon.8545000f1428deaf48c0c208aac7f230.svg";
export { ForwardRef as ReactComponent };